module.exports = __webpack_public_path__ + "img/shape-1.83092534.svg";